import {remCalc} from '_themeUtils'

export default {
    '.swiper-scrollbar': {
        borderRadius: remCalc(10),
        position: 'relative',
        touchAction: 'none',
        background: 'rgba(0, 0, 0, 0.1)',
    },
    '.swiper-scrollbar-disabled > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-disabled': {
        display: 'none !important',
    },
    '.swiper-horizontal > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-horizontal': {
        position: 'absolute',
        left: '1%',
        bottom: remCalc(4),
        top: 'auto',
        zIndex: 50,
        height: remCalc(4),
        width: 'calc(100% - 2 * 1%)',
    },
    '.swiper-vertical > .swiper-scrollbar,\n.swiper-scrollbar.swiper-scrollbar-vertical': {
        position: 'absolute',
        left: 'auto',
        right: remCalc(4),
        top: '1%',
        zIndex: 50,
        width: remCalc(4),
        height: 'calc(100% - 2 * 1%)',
    },
    '.swiper-scrollbar-drag': {
        height: '100%',
        width: '100%',
        position: 'relative',
        background: 'rgba(0, 0, 0, 0.5)',
        borderRadius: remCalc(10),
        left: '0',
        top: '0',
    },
    '.swiper-scrollbar-cursor-drag': {cursor: 'move'},
    '.swiper-scrollbar-lock': {display: 'none'},
}
